/**
 *
 * @dsc Show main spinner actions
 */

jQuery(function ($) {
    $('.woocommerce-form-login__submit, .woocommerce-form-register__submit, #vet-save-acc-settings').on('click', function(){
        $('.spinner-main').addClass('loaded');
    });
});